import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import COLOR from 'enums/COLOR';
import * as Calculation from 'types/Recipe/Calculation';
import * as Ingredient from 'types/Recipe/Detail/ErpNew/Ingredient';
import * as IngredientList from 'types/_general/Store/IngredientList';

export const AccordionHeader = (
	props: RecipeErpViewComponentProps & {
		mapping: Ingredient.Type;
		isLoaded: boolean;
		calculation: Calculation.Type;
	}
) => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	return (
		<>
			<span className={classes.index}>
				{t('recipe:STEP')} {props.mapping.segmentIndex + 1}
			</span>
			<strong title={props.mapping.ingredientId}>
				{IngredientList.getNameById(props.data.ingredients, props.mapping.ingredientId)}
			</strong>
			<FontAwesomeIcon icon={faArrowRight} className={classes.icon} />
			{Ingredient.hasSelectedProduct(props.mapping) ? (
				<span style={{ color: COLOR.PRIMARY }}>
					{Ingredient.getMappingsAsString(props.mapping)}
				</span>
			) : (
				<span style={{ color: 'grey' }}>{t('_general:NO_PRODUCT_ASSIGNED')}</span>
			)}
		</>
	);
};

const useStyles = tss.create({
	index: { color: 'grey', marginRight: '10px' },
	icon: { marginRight: '7px', marginLeft: '7px' },
});
